import React from 'react';
import {type IAsset} from '@netx/core-asset-next/schema';
import {AssetViewsProvider} from '../../contexts';
import {canManageAssetViews} from '../../enablers/canManageAssetViews';
import {AssetViews, type AssetViewsProps} from './AssetViews';

export interface AssetViewsContainerProps extends Omit<
	AssetViewsProps,
	'filter' | 'totalRows' | 'onBulkDelete'
> {
	asset?: IAsset;
}

/**
 * Container wrapper to provide and consume context for `<AssetViews />`
 * @param props Props
 * @returns JSX.Element
 */
/**
 * `AssetViewsContainer` is a container component that enriches `AssetViews` with context and data management for system group operations.
 */
export const AssetViewsContainer = ({
	asset,
	loading: _loading,
	...props
}: AssetViewsContainerProps) => {
	return (
		<AssetViewsProvider asset={asset}>
			{({loading, total, filter, createView}) => (
				<AssetViews
					{...props}
					filter={filter}
					loading={loading || _loading}
					totalRows={total}
					onCreate={canManageAssetViews(asset) ? () => createView() : undefined}
				/>
			)}
		</AssetViewsProvider>
	);
};
